export const enReporting = {
  AdomainQuickReport: 'Adomain Quick Report',
  AdomainQuickReportDescription: 'Use this report to understand quickly how brands reach your inventory. Compare demand partners layering deal data, ensure advertisers are performing as expected.',
  AdomainQuickReportPill: 'Adomain',
  AdvertiserRuleReport: 'Advertiser Rule Report',
  AppBundleQuickReport: 'App Bundle Quick Report',
  AppBundleQuickReportDescription: 'Use this report to get an app-level view of your performances. Useful to keep track of all your distribution channels, compare app integrations type along with device related KPIs.',
  AppBundleQuickReportPill: 'App Bundle',
  APSReport: 'APS Report',
  AuctionFillRateReport: 'Auction Fill Rate Report',
  AuctionQuickReport: 'Auction Quick Report',
  AuctionQuickReportDescription: 'Run this report to access supply-related data - ideal to monitor ad-break construction and potential yield optimizations across your inventory with most used metrics.',
  AuctionQuickReportPill: 'Auction',
  AuctionReport: 'Auction Report',
  AudienceSegmentForAllPublishersReport: 'Audience Segment Report For All Publishers',
  AudienceSegmentLiverampReport: 'Audience Segment Report',
  BidderQuickReport: 'Bidder Quick Report',
  BidderQuickReportDescription: 'Run this report to access demand-related data - ideal for bidder performances comparison using dedicated metrics focusing on auction participation KPIs, along with actionable analysis ratios, errors & latencies.',
  BidderQuickReportPill: 'Bidder',
  BidderReport: 'Bidder Report',
  BidFloorSettingReport: 'Bid Floor Setting Report',
  BrandSafetyTrackerReport: 'Brand Safety Tracker Report',
  CampaignQuickReport: 'Campaign Quick Report',
  CampaignQuickReportDescription: 'Use this report to dig into the performance of direct campaigns running through the Publica Campaign Manager. Use line-item dimensions to track campaign KPIs across inventory with insights down the creative level.',
  CampaignQuickReportPill: 'Campaign',
  CampaignReport: 'Campaign Report',
  ContentQuickReport: 'Content Quick Report',
  ContentQuickReportDescription: 'Use this report to access monetization KPIs broken down by content-level dimensions. View each slice of inventory to check top-performing Genres or Titles.',
  ContentQuickReportPill: 'Content',
  ContextualSegmentReport: 'Contextual Segment Report',
  CreativeReviewReport: 'Creative Review Report',
  CreativeValidationReport: 'Creative Validation Report',
  DealReport: 'Deal Report',
  DestinationReport: 'Destination Report',
  EleaAIEnrichmentBillingReport: 'Elea AI Enrichment Billing Report',
  EleaAIEnrichmentReport: 'Elea AI Enrichment Report',
  EleaAILanguageDetectionReport: 'Elea AI Language Detection Report',
  EleaAIScanAllReport: 'Elea AI Scan All Report',
  IASContentLevelPerformanceReport: 'IAS Content Level Performance Report',
  IASFirstPartyVASTTrackingReport: 'IAS First Party VAST Tracking Report',
  IASThirdPartyVASTTrackingReport: 'IAS Third Party VAST Tracking Report',
  InventoryRouteReport: 'Inventory Route Report',
  OutboundDealReport: 'Outbound Deal Report',
  PodHourlyReport: 'Pod Hourly Report',
  PublicaVaultJSONTrueLiftReport: 'Publica Vault JSON True Lift Report',
  PublicaVaultTrueLiftReport: 'Publica Vault True Lift Report',
  ReachAndFrequencyReport: 'Reach & Frequency Report',
  ReportingCopyQuery: 'Copy Query',
  ReportingEmailSubjectName: 'Email subject name',
  ReportingFilterNotEnabled: 'Filter is not enabled for this report.',
  ReportingInputAccessPointCredentials: 'Input access point credentials in General Settings to use S3 delivery option.',
  ReportingInvestigation: 'Investigation',
  ReportingInvestigationDescription: 'Investigation reports contain extended datasets, allowing for a more granular analysis.',
  ReportingLimitRows: 'Limit Rows',
  ReportingLimitRowsDescription: 'Use to retrieve only a given number of rows. Comes handy for a quick preview',
  ReportingOrderByDescription: 'Use to sort report based on any metric selected, ascending or descending.',
  ReportingPeriodRangeDescription: 'As scheduling makes this report a recurring one, period range operates as a moving preset date range.',
  ReportingQuery: 'Query',
  ReportingQueryWithAsterisk: 'Query *',
  ReportingQuickReports: 'Quick Reports',
  ReportingReceiveFullReport: 'Receive full report',
  ReportingReportName: 'Report Name',
  ReportingSelectMetricsToOrderBy: 'Please select some metrics to order by.',
  ReportingSetUpScheduleBelow: 'Set up schedule below',
  ReportingShareAsLink: 'Share as link',
  ReportingShowingFirst5000Rows: 'Showing first 5000 rows of data',
  ReportingShowingFullReport: 'Showing full report',
  ReportingSnackbarAdomainLimitRequired: 'Adomain filter requires a Limit between 1 and 500,000',
  ReportingSnackbarDownloadFailed: 'Download Failed. Please contact your administrator for further assistance.',
  ReportingSnackbarDownloadingReport: 'Downloading Report...',
  ReportingSnackbarEmailScheduledSuccess: "Got it! We'll email the report once it's ready",
  ReportingSnackbarFailedToLoadLastUpdatedTimestamp: 'Failed to load last updated timestamp for the report',
  ReportingSnackbarNameRequiredToSave: 'Report name required to save report',
  ReportingSnackbarSaved: 'Report saved',
  ReportingSnackbarSavedAsQuickReport: 'Saved as a Quick Report',
  ReportingSnackbarSavingReport: 'Saving Report...',
  ReportingSnackbarScheduledReportNeedsRecipients: 'To save a scheduled report, please enter some recipients',
  ReportingSnackbarSchedulingReportToBeEmailed: 'Scheduling report to be emailed...',
  ReportingSnackbarSelectDimensionAndMetricToDownload: 'To download a report, select at least one dimension and one metric',
  ReportingSnackbarSelectDimensionAndMetricToEmail: 'To email a report, select at least one dimension and one metric',
  ReportingSnackbarSelectDimensionAndMetricToPreview: 'To preview a report, select at least one dimension and one metric',
  ReportingSnackbarSelectDimensionAndMetricToSave: 'To save a report, select at least one dimension and one metric',
  ReportingSnackbarTheDateRangeExceedsMaximum: 'The maximum date range that you can select for this report is: {{count}} days.',
  ReportingSnackbarUnableToSaveReport: 'Unable to save report',
  ReportingSnackbarVenueIDRequired: 'At least one venue ID is required',
  ReportingSubjectNameDescription: 'If the subject field is empty, the report name will match the email subject.',
  ReportingTableWithAsterisk: 'Table *',
  ReportingTooltipDownload: 'Get report in a CSV file now.',
  ReportingTooltipEmail: 'Run report and email when ready. Expect longer delivery times for larger reports.',
  ReportingTooltipFailedToCopy: 'Failed to copy. Please check browser persmissions',
  ReportingTooltipFilterState: 'States filter only works if a single country is selected',
  ReportingTooltipPreview: 'Data looks good? Request the full report by email, you should get it shortly. Using sort on any column will refresh the preview data.',
  ReportingTooltipPreviewNewTab: "Preview report's data in a new tab",
  ReportingTooltipQuery: 'Inspect query generated by this report.',
  ReportingTooltipQueryCopied: 'Query Copied',
  ReportingTooltipReportReady: 'Report is ready for instant download.',
  ReportingTooltipTimeRange: 'Quick Report data only available from 3/1/24.',
  ReportingUnableToScheduleYearToDateReport: 'Cannot schedule year-to-date report on a daily interval.',
  ShareOfVoiceReport: 'Share Of Voice Report',
  SmartFloorsReport: 'Smart Floors Report',
  SSAIReport: 'SSAI Report',
  SSAIUserActivityReport: 'SSAI User Activity Report',
  SSPReport: 'SSP Report',
  ThirdPartyTrackerDomainReport: 'Third Party Tracker Domain Report',
  TrafficShapingReport: 'Traffic Optimization Report',
  TTDReport: 'TTD Report',
  UniqueUserReport: 'Unique Users Report',
  UnknownReport: 'Unknown Report',
};
